module.exports = __webpack_public_path__ + "img/pd-img51.ee82aacf.jpg";